<div class="header">
    <div class="logo" routerLinkActive="active" [routerLink]="['/shore']"><h1 class="header-text">THE SHORE</h1></div>

    <div class="profile-section">
    </div>
    
    <div class="settings-container">
        <h1 class="name">Welcome {{name}}!</h1>
    </div>
</div>

